export default "__VITE_ASSET__BeJ2_cGd__"